import { Extension } from '@tiptap/core'
import type { GeneralOptions } from '@/notebook/type'
import TextDropdown from './components/TextDropdown.vue'

export type TextBubbleOptions = {} & GeneralOptions<TextBubbleOptions>

export const TextBubble = Extension.create<TextBubbleOptions>({
  name: 'text-bubble',
  addOptions() {
    return {
      ...this.parent?.(),
      toolbar: false,
      button: () => ({
        component: TextDropdown,
        componentProps: {},
      }),
    }
  },
})

export default TextBubble
